import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { config } from '../../core/config/config';

@Component({
  selector: 'app-hero',
  imports: [TranslatePipe],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.css'
})
export class HeroComponent {
  config = config;
  constructor(private router: Router) { }

  onClick() {
    this.router.navigate(['/menu']);
  }

}
